/**
 * Displays a customer's feature flags.
 *
 * @param {object} classes - CSS classes object containing card styles
 * @param {object} featureFlags - Key-value pairs of feature flag names and their boolean/string values
 * @returns {JSX.Element}
 */
function FeatureFlags({ classes, featureFlags = {} }) {
    return (
        <div className={classes.card}>
            <p className="text-[1rem] font-bold">Feature Flags</p>
            <div className="grid grid-cols-2 gap-4 mt-3">
                {Object.entries(featureFlags).map(([key, value]) => (
                    <div key={key} className="flex flex-col items-start text-sm min-w-0">
                        <span className="text-xs opacity-[0.54] break-all text-left">{key}</span>
                        {String(value)}
                    </div>
                ))}
            </div>
        </div>
    );
}

export { FeatureFlags };
